import api from 'api'

const FETCH_REQUEST = 'realhub/deadline/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/deadline/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/deadline/FETCH_FAILURE'
const CREATE_REQUEST = 'realhub/deadline/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/deadline/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/deadline/CREATE_FAILURE'
const DELETE_REQUEST = 'realhub/deadline/DELETE_REQUEST'
const DELETE_SUCCESS = 'realhub/deadline/DELETE_SUCCESS'
const DELETE_FAILURE = 'realhub/deadline/DELETE_FAILURE'

// Initial State
const initialState = {
  result: [],
  loaded: false,
  loading: false,
  creating: false,
  deleting: [],
  errors: [],
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload){
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function deleteRequest(id){
  return {
    type: DELETE_REQUEST,
    payload: id,
  }
}

export function deleteSuccess(id){
  return {
    type: DELETE_SUCCESS,
    payload: id,
  }
}

export function deleteFailure(id, errors = []){
  return {
    type: FETCH_FAILURE,
    payload: id,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

export function loadDeadlines(options){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api('brandhub/publication_deadlines.json', options)
      .then(response => (
        response.json().then(json => ({ json, response }))
      ))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }
        dispatch(fetchSuccess(json))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

export function createDeadline(deadline, options, callback){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      deadline,
    }),
  }

  return (dispatch, getState) => {
    // Set Loading
    dispatch(createRequest())

    // TODO: Remove when api works
    const promise = new Promise((resolve) => {
      setTimeout(() => {
        resolve()
      }, 1000)
    })
      .then(() => {
        dispatch(createSuccess())
      })

    return promise
  }
}

// TODO: Refactor deleting so it's possible to handle every item deleting status
export function deleteDeadline(id){
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    // Set Loading
    dispatch(deleteRequest(id))

    // TODO: Remove when api works
    const promise = new Promise((resolve) => {
      setTimeout(() => {
        resolve(deadlinesData)
      }, 1000)
    })
      .then(() => {
        dispatch(deleteSuccess(id))
      })
      .catch(() => {
        dispatch(deleteFailure(id))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  const { payload, type, errors } = action

  switch (type){
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        result: payload,
        errors: [],
      })
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        loaded: false,
        errors,
      })
    case CREATE_REQUEST:
      return Object.assign({}, state, {
        creating: true,
      })
    case CREATE_SUCCESS:
      return Object.assign({}, state, {
        creating: false,
        errors: [],
      })
    case CREATE_FAILURE:
      return Object.assign({}, state, {
        creating: false,
        errors,
      })
    case DELETE_REQUEST:
      return Object.assign({}, state, {
        deleting: [...state.deleting, payload],
      })
    case DELETE_SUCCESS:
      return Object.assign({}, state, {
        deleting: state.deleting.filter(id => id !== payload),
        errors: [],
      })
    case DELETE_FAILURE:
      return Object.assign({}, state, {
        deleting: state.deleting.filter(id => id !== payload),
        errors,
      })
    default:
      return state
  }
}
